import { css } from '@emotion/react';
import theme from 'shared/styles/themes';

export default css({
  '.reset-password-form': {
    '&__submit-btn': {
      marginTop: theme.space[4],
    },
  },
});
